import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import DeviationDumbView from '../../DeviationViews/Dumbo';
import SubfoldersIcon from '@wix/da-ds/pkg/Icons/24x24/Subfolders';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import folderSropdownDesktopStyles from './FolderDropdownDesktop.scss';
const FolderThumb = ({ folder , hasSubfolders  })=>{
    const deviation = folder.thumb;
    if (!deviation) {
        return null;
    }
    const previewProps = {
        deviation,
        width: 114,
        height: 64
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: folderSropdownDesktopStyles['thumb-wrapper']
    }, /*#__PURE__*/ React.createElement(DeviationDumbView, _extends({}, previewProps, {
        className: folderSropdownDesktopStyles['thumb']
    })), hasSubfolders && /*#__PURE__*/ React.createElement(SubfoldersIcon, {
        size: IconSize.SMALL,
        className: folderSropdownDesktopStyles['subfolders-icon']
    }));
};
FolderThumb.displayName = 'FolderThumb';
export default FolderThumb;
